export default __webpack_public_path__ + "static/media/shivanna_daughter.0d73ff40.jpg";